
<template>
  <div class="col-12 grid-margin">
    <div
      id="loadingmessage"
      style="text-align:center;margin: 0px; padding: 0px; position: fixed; right: 0px; top: 0px; width: 100%; height: 100%; background-color: white; z-index: 30001; opacity: 0.8;"
      v-if="loading"
    >
      <p style="position: absolute; color: White; top: 40%; left: 50%;">
        <img src="../../assets/loader.gif" />
      </p>
    </div>
    <div class="card">
      <div class="card-body">
        <h4 class="card-title">Add a Blog</h4>
        <form class="form-sample" @submit="onSubmit" >

        <div class="col-md-6 form-group" style="font-size:16px!important">
                <label for="exampleInputEmail1">Please Upload Blog Image</label>
                <br />
                <input
                  type="file"
                  class="images"
                  accept="image/*"
                  id="file7"
                  ref="file7"
                  v-on:change="handleFileUpload7()"
                />

                <!--input input type="file" :name="'images' + (index + 1)" accept="image/*" @change="previewImage(index, $event)"-->
              </div>
          <div class="col-md-4">
                <div v-if="url7" width="80px" height="80px" class="card" id="preview">
                  <img width="100%" height="100%" :src="url7" />
                </div>
              </div>


          <div class="col-md-6 pt-4 pb-4 pl-0">
            <div class="row">
             
              <div class="col-md-4">
                <div  width="80px" height="80px" class="card" id="preview">
                  <img width="100%" height="100%"  />
                </div>
              </div>
            </div>
          </div>
          <div class="row" style="font-size:16px!important">
            <div class="col-md-4 pb-2">
              <b-form-group label="Title">
                <b-form-input type="text" v-model="title" required></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-10 pb-2">
             
              <froala  id="edit" :tag="'textarea'" :config="config" v-model="text"></froala>
            </div>            
            <hr class="pt-2" />
          </div>
          <hr/>
          <b-button variant="primary" class="btn-fw" type="submit">Submit</b-button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios" ;
export default {
  // name: "addablog",
  // props: {
  //   caption: {
  //     type: String,
  //     default: "Add a blog"
  //   }
  // },
  data: () => {
    return {
        loading:false,
        title :"",
        text:"",
        url7 :null,
        file7 :null,
        id1:"",
       turt: new FormData(),
    };
  },
 
  methods: { 
      show(){
      console.log( "file7is=",this.file7)
      },

    handleFileUpload7() {
      this.file7 = this.$refs.file7.files[0];
      this.url7 = URL.createObjectURL(this.file7);
      this.show()
    },
    onSubmit(evt) {
      evt.preventDefault();
        this.loading = true;
      axios({
        method: "POST",
        url: "/blog/add",
        data: {
            title:this.title,
            text : this.text,
        },
        headers:
        {
             "x-auth-token": localStorage.getItem("token"),
        }
      })
        .then((response) => {
          if (response.data.status == true) {
           this.id1 = response.data.data._id
           this.turt.append("id", this.id1);
            this.turt.append("image", this.file7);
             axios({
               method:"POST",
               url:"/blog/imageupload",
               data:this.turt,
                headers:
               {
             "x-auth-token": localStorage.getItem("token"),
                 }
             })
             .then((response) =>{
               console.log(" image success")

             })

            alert("success");
             this.loading = false;
             this.clear();
          }     
        })
        .catch(err => {
          console.log(err);
          
        });
    },
    clear(){
      this.title =" ",
      this.text =" ",
      this.url7 =" "
    }
  }
};
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
</style>